import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import { LanguageService } from '../../core/services/language.service';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { TopbarComponent } from '../topbar/topbar.component';
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
  RouterModule,
} from '@angular/router';
import { CustomizerComponent } from '../customizer/customizer.component';
import { FooterComponent } from '../footer/footer.component';
import { AlertComponent } from '../../Component/alert/alert.component';
import { LoaderComponent } from '../../Component/loader/loader.component';

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [
    SidebarComponent,
    TopbarComponent,
    RouterModule,
    CustomizerComponent,
    FooterComponent,
    AlertComponent,
    LoaderComponent,
  ],
  template: `
    <div
      class="text-base bg-body-bg text-body font-public dark:text-zink-100 dark:bg-zink-800 group-data-[skin=bordered]:bg-body-bordered group-data-[skin=bordered]:dark:bg-zink-700"
    >
      <div class="group-data-[sidebar-size=sm]:min-h-sm group-data-[sidebar-size=sm]:relative">
        <app-sidebar></app-sidebar>
        <app-topbar></app-topbar>
        <div class="relative min-h-screen group-data-[sidebar-size=sm]:min-h-sm">
          <div
            class="group-data-[sidebar-size=lg]:ltr:md:ml-vertical-menu group-data-[sidebar-size=lg]:rtl:md:mr-vertical-menu group-data-[sidebar-size=md]:ltr:ml-vertical-menu-md group-data-[sidebar-size=md]:rtl:mr-vertical-menu-md group-data-[sidebar-size=sm]:ltr:ml-vertical-menu-sm group-data-[sidebar-size=sm]:rtl:mr-vertical-menu-sm pt-[calc(theme('spacing.header')_*_1)] pb-[calc(theme('spacing.header')_*_0.8)] px-4 group-data-[navbar=bordered]:pt-[calc(theme('spacing.header')_*_1.3)] group-data-[navbar=hidden]:pt-0 group-data-[layout=horizontal]:mx-auto group-data-[layout=horizontal]:max-w-screen-2xl group-data-[layout=horizontal]:px-0 group-data-[layout=horizontal]:group-data-[sidebar-size=lg]:ltr:md:ml-auto group-data-[layout=horizontal]:group-data-[sidebar-size=lg]:rtl:md:mr-auto group-data-[layout=horizontal]:md:pt-[calc(theme('spacing.header')_*_1.6)] group-data-[layout=horizontal]:px-3 group-data-[layout=horizontal]:group-data-[navbar=hidden]:pt-[calc(theme('spacing.header')_*_0.9)]"
          >
            <div class="container-fluid group-data-[content=boxed]:max-w-boxed mx-auto">
              <app-loader></app-loader>
              @if (cargandoPosiciones) {
                <div
                  class="fixed top-0 left-0 right-0 bottom-0 flex items-center justify-center z-[99999] bg-black bg-opacity-60"
                >
                  <div class="size-20 border-4 rounded-full animate-spin border-l-transparent border-custom-500"></div>
                </div>
              }
              <router-outlet></router-outlet>
            </div>
          </div>
          <app-footer></app-footer>
        </div>
        <app-alert></app-alert>
      </div>
    </div>
    <app-customizer></app-customizer>
  `,
  styleUrl: './layout.component.scss',
  providers: [LanguageService],
})
export class LayoutComponent implements OnInit {
  private store = inject(Store);
  private destroyRef = inject(DestroyRef);

  cargandoPosiciones: boolean = false;

  layoutType!: string;

  constructor(private router: Router) {
    this.router.events.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(event => {
      if (event instanceof NavigationStart) {
        this.cargandoPosiciones = true;
      } else if (
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel ||
        event instanceof NavigationError
      ) {
        this.cargandoPosiciones = false;
        const element = document.querySelector('main') as HTMLElement;
        if (element) {
          element.scrollTop = 0;
        }
      }
    });
  }

  ngOnInit() {
    this.store
      .select('layout')
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data: any) => {
        this.layoutType = data.LAYOUT;
        document.documentElement.setAttribute('data-layout', data.LAYOUT);
        document.documentElement.setAttribute('data-sidebar', data.SIDEBAR_COLOR);
        data.LAYOUT == 'vertical' ? document.documentElement.setAttribute('data-sidebar-size', data.SIDEBAR_SIZE) : '';
        document.documentElement.setAttribute('data-mode', data.LAYOUT_MODE);
        document.documentElement.setAttribute('data-topbar', data.TOPBAR_COLOR);
        document.documentElement.setAttribute('data-skin', data.LAYOUT_SKIN);
        document.documentElement.setAttribute('data-navbar', data.LAYOUT_NAVIGATION);
        document.documentElement.setAttribute('data-content', data.LAYOUT_WIDTH);
        document.documentElement.setAttribute('dir', data.LAYOUT_DIRECTION);
      });
  }
}
